import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from '@lion-design/core';
import { RootState } from '@Redux/detail/store';
import * as Icons from '@components/Common/Icons';
import SlidePage from '@components/Common/SlidePage';
import {
    GroupDetailPrice,
    GroupAllDetailMore,
    GroupAllList,
    GroupAllTours,
    GroupAllCalendar,
    NextStepBtn,
} from '@components/DetailPage';

import {
    setIsCalendarShowM,
    setContactTelOpen,
    setNextStepLoading,
    setAbroadDepOpen,
} from '@Redux/detail/Group/actions';
import ContactStaff from '@components/Common/ContactStaff';
import styles from '../style.module.scss';
import Contactlightbox from '@components/Common/Contactlightbox';

function Register() {
    const { GroupInfo, IsB2E, TelType, IsPreview } = useSelector(
        (store: RootState) => store.groupReducer
    );
    const { isContactTelOpen, abroadDepOpen, isAnchorShow } = useSelector(
        (store: RootState) => store.switcherReducer
    );
    const { calljson } = useSelector((store: RootState) => store.callInfoReducer);
    const dispatch = useDispatch();
    const [isFeeOpen, setIsFeeOpen] = useState<boolean>(false);
    const [isMoreOpen, setIsMoreOpen] = useState<boolean>(false);
    const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
    const priceRef = useRef<any>(null);
    const { t } = useTranslation();

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    // 若為 "額滿"、"關團"、"取消"、"關團(因疫情）"，則 disable 按鈕
    const disabledBtn = [3, 5, 7, 99].includes(GroupInfo.Status);
    // 即將開放(僅按鈕disable其餘文案正常顯示)
    const comingSoon = [9].includes(GroupInfo.Status);

    const currency = GroupInfo.CurrencyCode || '';

    const showOrigPrice = (!!GroupInfo.IsVip || !!IsB2E) && (
        <div className={styles.orgprice}>
            原價:<span>{GroupInfo.OrigPrice}人/起</span>
        </div>
    );

    // 初始和離開頁面off loading狀態
    useEffect(() => {
        const handleBeforeUnload = () => {
            setTimeout(() => {
                dispatch(setNextStepLoading(false));
            }, 1000);
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [dispatch]);

    React.useEffect(() => {
        if (isCalendarOpen) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [isCalendarOpen]);

    const statusText = (status: number) => {
        switch (status) {
            case 1:
                return '報名';
            case 2:
                return '候補';
            case 3:
                return '額滿';
            case 4:
                return '請洽專員';
            case 5:
                return t('closeGroup');
            case 6:
                return '預訂';
            case 7:
                return '取消';
            case 8:
                return '我有意願';
            case 9:
                return '即將開賣';
            // 因應疫情
            case 99:
                return t('closeGroup');
            default:
                return '';
        }
    };

    function lightBoxSwitch(switcher: boolean) {
        // setContactMember(switcher);
        dispatch(setAbroadDepOpen(switcher));
        dispatch(setNextStepLoading(switcher));
    }

    useEffect(() => {
        dispatch(setIsCalendarShowM(isCalendarOpen));
    }, [isCalendarOpen, dispatch]);

    return (
        <div className={styles['register-wrapper']}>
            <div className={styles['price-wrapper']}>
                <div className={styles['price-info']}>
                    <div className={styles['price-box']}>
                        {disabledBtn ? (
                            <div className={styles.tips}>
                                <Icons.Time />
                                親愛的！你慢了一步！
                            </div>
                        ) : (
                            <>
                                {showOrigPrice}
                                <div className={styles.price}>
                                    <span>
                                        {GroupInfo.Status == 6
                                            ? '近期上架'
                                            : `${currency} ${GroupInfo.Price}`}
                                    </span>
                                    {GroupInfo.Status !== 6 && '人/起'}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className={styles.btns} ref={priceRef}>
                    <Button
                        className={styles['btn-primary-border']}
                        onClick={() => setIsCalendarOpen(true)}
                    >
                        選擇出發日期
                    </Button>
                    {!disabledBtn && (
                        <Button
                            className={cN(styles['show-pc'])}
                            onClick={() => setIsFeeOpen(true)}
                        >
                            費用說明
                        </Button>
                    )}
                    <NextStepBtn
                        typeClass="main"
                        statusText={statusText(GroupInfo.Status)}
                        disabledBtn={disabledBtn}
                        comingSoon={comingSoon}
                    />
                </div>
                <SlidePage
                    visible={isCalendarOpen}
                    setIsVisible={setIsCalendarOpen}
                    title="選擇出發日期"
                    side="bottom"
                >
                    <>
                        <GroupAllTours />
                        <GroupAllCalendar slidePageVisible={setIsCalendarOpen} />
                        <GroupAllList />
                    </>
                </SlidePage>
            </div>
            {isMobile && isAnchorShow && (
                <div className={styles.stickyFooter}>
                    {!disabledBtn && (
                        <div className={styles.price}>
                            <span className={styles['price_rate']}>
                                {GroupInfo.Status == 6
                                    ? '近期上架'
                                    : `${currency}${GroupInfo.Price}`}
                            </span>
                            {GroupInfo.Status !== 6 && '人/起'}
                        </div>
                    )}
                    {!disabledBtn && (
                        <div className={styles['price_info']} onClick={() => setIsFeeOpen(true)}>
                            費用說明
                        </div>
                    )}
                    <NextStepBtn
                        statusText={statusText(GroupInfo.Status)}
                        disabledBtn={disabledBtn}
                        comingSoon={comingSoon}
                    />
                </div>
            )}
            {/* 光箱 */}
            <GroupDetailPrice open={isFeeOpen} ToggleLightBox={() => setIsFeeOpen(false)} />
            <GroupAllDetailMore open={isMoreOpen} ToggleLightBox={() => setIsMoreOpen(false)} />
            {!IsPreview && (
                <ContactStaff
                    open={isContactTelOpen}
                    ToggleLightBox={() => {
                        dispatch(setContactTelOpen(false));
                        dispatch(setNextStepLoading(false));
                    }}
                    callJson={calljson}
                    TelType={TelType}
                    GroupInfo={GroupInfo}
                />
            )}
            <Contactlightbox state={abroadDepOpen} setState={lightBoxSwitch} />
        </div>
    );
}

export default Register;
